import React, { useEffect, useState } from "react";
import { Button } from "../../../../controls";
import { Dialog } from "../../../../layout";
import RegisterForm from "../Register/OpenReg/RegisterForm";
import { lsGet } from "hooks";

const RegisterAct = () => {
  const activeReg = lsGet("activeReg");
  const [showRegForm, setShowRegForm] = useState(false);
  const [regCloseable, setRegCloseable] = useState(true);

  const handleSwitchReg = () => {
    setShowRegForm(!showRegForm);
  };

  useEffect(() => {
    if (!activeReg || (activeReg && activeReg.status === 2)) {
      setShowRegForm(true);
      setRegCloseable(false);
    }
    return () => {};
  }, [activeReg]);

  return (
    <>
      {activeReg && activeReg.id ? (
        <Button
          onClick={handleSwitchReg}
          variant="text"
          className="!min-w-[220px]"
          fullWidth
          sx={{ display: "block", "& .MuiButton-startIcon": { mr: 0 } }}
        >
          <div className="grid gap-[1px] items-center text-left pl-[5px]">
            <span className="text-[16px]">
              {activeReg.register && activeReg.register.name}
            </span>

            <div className="flex gap-1 items-center">
              <span className="text-[12px]">
                {activeReg.outlet && activeReg.outlet.outletName}
              </span>
              <span className="text-gray-300">|</span>
              <span className="text-[12px] underline">Switch</span>
            </div>
          </div>
        </Button>
      ) : (
        ""
      )}

      {/* Open Register form*/}
      {showRegForm && (
        <Dialog show={showRegForm} onClose={false} maxWidth="sm">
          <RegisterForm
            {...{ setShowForm: setShowRegForm, regCloseable: regCloseable }}
          />
        </Dialog>
      )}
    </>
  );
};

export default RegisterAct;
